

// export default FormsScroll;
import  { useState, useEffect } from "react";
import "./FormsScroll.css";

function FormsScroll() {
  const [activeForm, setActiveForm] = useState("contact");
  const [currentIndex, setCurrentIndex] = useState(0);

  const BACKEND = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  const [contactData, setContactData] = useState({
    name: "",
    mobile: "",
    email: "",
    problem: "",
  });

  const [requirementData, setRequirementData] = useState({
    name: "",
    mobile: "",
    email: "",
    problem: "",
  });

  const slides = [
    "validation",
    "log",
    "mind",
    "system",
    "payment",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Handle input change for each form
  const handleContactChange = (e) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });
  };

  const handleRequirementChange = (e) => {
    setRequirementData({ ...requirementData, [e.target.name]: e.target.value });
  };

  // Contact form submit
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${BACKEND}/form/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contactData),
      });
      const result = await res.json();
      alert(result.message || "Thank you! We'll be in touch soon.");
      setContactData({ name: "", mobile: "", email: "", problem: "" });
    } catch (err) {
      console.error(err);
      alert("Error submitting contact form");
    }
  };

  // Requirement form submit
  const handleRequirementSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${BACKEND}/form/requirement`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requirementData),
      });
      const result = await res.json();
      alert(result.message || "Thank you! Your requirement has been submitted.");
      setRequirementData({ name: "", mobile: "", email: "", problem: "" });
    } catch (err) {
      console.error(err);
      alert("Error submitting requirement form");
    }
  };

  const renderSlideContent = (slide) => {
    switch (slide) {
      case "validation":
        return (
          <svg className="carousel-svg val-svg" viewBox="0 0 400 400" width="100%" height="100%">
            <defs>
              <linearGradient id="valGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ff5e00" />
                <stop offset="100%" stopColor="#ff9900" />
              </linearGradient>
              <linearGradient id="valGrad2" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#171717" stopOpacity="0.8" />
                <stop offset="100%" stopColor="#2c2c2c" stopOpacity="0.9" />
              </linearGradient>
              <linearGradient id="glowCheck" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#00ff87" />
                <stop offset="100%" stopColor="#60efff" />
              </linearGradient>
              <filter id="svgGlow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="6" result="blur" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" />
              </filter>
            </defs>
            <rect width="400" height="400" fill="transparent" />
            <path d="M 0 40 L 400 40 M 0 80 L 400 80 M 0 120 L 400 120 M 0 160 L 400 160 M 0 200 L 400 200 M 0 240 L 400 240 M 0 280 L 400 280 M 0 320 L 400 320 M 0 360 L 400 360" stroke="#f0f0f0" strokeWidth="0.5" opacity="0.1" />
            <path d="M 40 0 L 40 400 M 80 0 L 80 400 M 120 0 L 120 400 M 160 0 L 160 400 M 200 0 L 200 400 M 240 0 L 240 400 M 280 0 L 280 400 M 320 0 L 320 400 M 360 0 L 360 400" stroke="#f0f0f0" strokeWidth="0.5" opacity="0.1" />

            <rect x="50" y="60" width="300" height="280" rx="16" fill="url(#valGrad2)" stroke="#ff5e00" strokeWidth="1" />
            <rect x="50" y="60" width="300" height="40" rx="16" fill="#1e1e1e" />
            <rect x="50" y="85" width="300" height="15" fill="#1e1e1e" />
            <circle cx="75" cy="80" r="5" fill="#ff5f56" />
            <circle cx="90" cy="80" r="5" fill="#ffbd2e" />
            <circle cx="105" cy="80" r="5" fill="#27c93f" />
            <text x="200" y="84" fill="#a8a8a9" fontSize="11" textAnchor="middle" fontWeight="bold">Idea Validation Form</text>

            <rect x="80" y="120" width="120" height="15" rx="4" fill="#ff5e00" opacity="0.2" />
            <rect x="80" y="125" width="80" height="5" rx="2.5" fill="#ff5e00" opacity="0.8" />
            <rect x="80" y="145" width="240" height="30" rx="6" fill="#3a3a3a" stroke="#555" strokeWidth="0.5" />
            <circle cx="95" cy="160" r="5" fill="#ff5e00" />
            <line x1="110" y1="160" x2="260" y2="160" stroke="#888" strokeWidth="3" strokeLinecap="round" />

            <rect x="80" y="195" width="120" height="15" rx="4" fill="#ff5e00" opacity="0.2" />
            <rect x="80" y="200" width="95" height="5" rx="2.5" fill="#ff5e00" opacity="0.8" />
            <rect x="80" y="220" width="240" height="50" rx="6" fill="#3a3a3a" stroke="#555" strokeWidth="0.5" />
            <line x1="95" y1="235" x2="280" y2="235" stroke="#666" strokeWidth="3" strokeLinecap="round" />
            <line x1="95" y1="247" x2="240" y2="247" stroke="#666" strokeWidth="3" strokeLinecap="round" />
            <line x1="95" y1="259" x2="180" y2="259" stroke="#666" strokeWidth="3" strokeLinecap="round" />

            <rect className="svg-btn-pulse" x="80" y="290" width="100" height="30" rx="6" fill="url(#valGrad1)" />
            <text x="130" y="309" fill="#fff" fontSize="10" fontWeight="bold" textAnchor="middle">Validate</text>

            <g transform="translate(10, 0)">
              <g className="floating-illustration">
                <circle cx="280" cy="280" r="45" fill="#1f362b" stroke="#00ff87" strokeWidth="2" filter="url(#svgGlow)" />
                <circle cx="280" cy="280" r="35" fill="url(#glowCheck)" opacity="0.25" className="pulse-slow" />
                <path d="M 262 280 L 274 292 L 298 268" stroke="#00ff87" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" className="draw-checkmark" />
              </g>
            </g>
          </svg>
        );
      case "log":
        return (
          <svg className="carousel-svg log-svg" viewBox="0 0 400 400" width="100%" height="100%">
            <defs>
              <linearGradient id="logGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#1a1a1a" />
                <stop offset="100%" stopColor="#0d0d0d" />
              </linearGradient>
              <linearGradient id="accentGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#00f0ff" />
                <stop offset="100%" stopColor="#7000ff" />
              </linearGradient>
            </defs>
            <rect width="400" height="400" fill="transparent" />
            
            <rect x="40" y="50" width="320" height="300" rx="12" fill="url(#logGrad)" stroke="#333" strokeWidth="1.5" />
            <path d="M 40 62 A 12 12 0 0 1 52 50 L 348 50 A 12 12 0 0 1 360 62 L 360 85 L 40 85 Z" fill="#222" />
            <circle cx="65" cy="67" r="5" fill="#ff5f56" />
            <circle cx="80" cy="67" r="5" fill="#ffbd2e" />
            <circle cx="95" cy="67" r="5" fill="#27c93f" />
            <text x="200" y="71" fill="#888" fontSize="11" textAnchor="middle" fontWeight="bold">system_logs.log</text>

            <g fill="#00ff66" fontSize="10" fontFamily="Courier, monospace" opacity="0.95">
              <text x="60" y="120" className="log-line-1"><tspan fill="#888">[12:44:02]</tspan> <tspan fill="#00f0ff">INFO</tspan> Initialize Idea validation process...</text>
              <text x="60" y="145" className="log-line-2"><tspan fill="#888">[12:44:03]</tspan> <tspan fill="#7000ff">AI_ENG</tspan> Reading market sentiment databases...</text>
              <text x="60" y="170" className="log-line-3"><tspan fill="#888">[12:44:05]</tspan> <tspan fill="#ff007f">SUCCESS</tspan> Sentiment score compiled: <tspan fill="#fff" fontWeight="bold">88.4%</tspan></text>
              <text x="60" y="195" className="log-line-4"><tspan fill="#888">[12:44:06]</tspan> <tspan fill="#00ff66">MATCH</tspan> Found 14 matched SaaS frameworks.</text>
              <text x="60" y="220" className="log-line-5"><tspan fill="#888">[12:44:09]</tspan> <tspan fill="#ffbd2e">WARN</tspan> High competitor density in District 4.</text>
              <text x="60" y="245" className="log-line-6"><tspan fill="#888">[12:44:11]</tspan> <tspan fill="#00f0ff">INFO</tspan> Generating pricing & monetization matrix...</text>
              <text x="60" y="270" className="log-line-7"><tspan fill="#888">[12:44:12]</tspan> <tspan fill="#00ff66">DONE</tspan> Validation report generated successfully!</text>
              
              <text x="60" y="295" fill="#fff" className="blinking-cursor">&gt; system_idle_ <tspan fill="#00f0ff" className="cursor-block">█</tspan></text>
            </g>

            <g transform="translate(10, -10)">
              <g className="floating-illustration">
                <rect x="290" y="240" width="80" height="80" rx="10" fill="#171717" stroke="url(#accentGrad)" strokeWidth="2" opacity="0.9" />
                <path d="M 305 295 L 320 270 L 335 285 L 355 255" fill="none" stroke="#00f0ff" strokeWidth="3" strokeLinecap="round" className="log-chart-path" />
                <circle cx="355" cy="255" r="4" fill="#7000ff" className="pulse-slow" />
              </g>
            </g>
          </svg>
        );
      case "mind":
        return (
          <svg className="carousel-svg mind-svg" viewBox="0 0 400 400" width="100%" height="100%">
            <defs>
              <linearGradient id="mindCenter" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#7000ff" />
                <stop offset="100%" stopColor="#00f0ff" />
              </linearGradient>
              <linearGradient id="nodeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ff007f" />
                <stop offset="100%" stopColor="#7000ff" />
              </linearGradient>
              <filter id="mindGlow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="8" result="glow" />
                <feComposite in="SourceGraphic" in2="glow" operator="over" />
              </filter>
            </defs>
            <rect width="400" height="400" fill="transparent" />

            <g stroke="#7000ff" strokeWidth="2" opacity="0.6" strokeDasharray="6 4" className="mind-connections">
              <line x1="200" y1="200" x2="100" y2="100" />
              <line x1="200" y1="200" x2="300" y2="100" />
              <line x1="200" y1="200" x2="100" y2="300" />
              <line x1="200" y1="200" x2="300" y2="300" />
            </g>

            <circle cx="200" cy="200" r="65" fill="none" stroke="#00f0ff" strokeWidth="1" opacity="0.3" className="mind-pulse-ring-1" />
            <circle cx="200" cy="200" r="95" fill="none" stroke="#7000ff" strokeWidth="1" opacity="0.2" className="mind-pulse-ring-2" />

            <g className="central-node">
              <circle cx="200" cy="200" r="45" fill="url(#mindCenter)" filter="url(#mindGlow)" />
              <text x="200" y="204" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle" fontFamily="Montserrat, sans-serif">MY IDEA</text>
            </g>

            <g className="mind-node-1" transform="translate(100, 100)">
              <circle cx="0" cy="0" r="28" fill="#1e1e2f" stroke="#ff007f" strokeWidth="2" />
              <circle cx="0" cy="0" r="28" fill="url(#nodeGrad)" opacity="0.1" />
              <text x="0" y="4" fill="#ff007f" fontSize="10" fontWeight="bold" textAnchor="middle" fontFamily="Montserrat, sans-serif">Skills</text>
            </g>

            <g className="mind-node-2" transform="translate(300, 100)">
              <circle cx="0" cy="0" r="28" fill="#1e1e2f" stroke="#00f0ff" strokeWidth="2" />
              <circle cx="0" cy="0" r="28" fill="url(#mindCenter)" opacity="0.1" />
              <text x="0" y="4" fill="#00f0ff" fontSize="10" fontWeight="bold" textAnchor="middle" fontFamily="Montserrat, sans-serif">Sector</text>
            </g>

            <g className="mind-node-3" transform="translate(100, 300)">
              <circle cx="0" cy="0" r="28" fill="#1e1e2f" stroke="#00ff66" strokeWidth="2" />
              <circle cx="0" cy="0" r="28" fill="#00ff66" opacity="0.1" />
              <text x="0" y="4" fill="#00ff66" fontSize="10" fontWeight="bold" textAnchor="middle" fontFamily="Montserrat, sans-serif">Goals</text>
            </g>

            <g className="mind-node-4" transform="translate(300, 300)">
              <circle cx="0" cy="0" r="28" fill="#1e1e2f" stroke="#ff9900" strokeWidth="2" />
              <circle cx="0" cy="0" r="28" fill="#ff9900" opacity="0.1" />
              <text x="0" y="4" fill="#ff9900" fontSize="10" fontWeight="bold" textAnchor="middle" fontFamily="Montserrat, sans-serif">Tech</text>
            </g>
          </svg>
        );
      case "system":
        return (
          <svg className="carousel-svg system-svg" viewBox="0 0 400 400" width="100%" height="100%">
            <defs>
              <linearGradient id="sysPlatform" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#2e2e42" />
                <stop offset="100%" stopColor="#151522" />
              </linearGradient>
              <linearGradient id="sysLight" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#00ff87" />
                <stop offset="100%" stopColor="#60efff" />
              </linearGradient>
              <filter id="sysGlow" x="-25%" y="-25%" width="150%" height="150%">
                <feGaussianBlur stdDeviation="8" result="blur" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" />
              </filter>
            </defs>
            <rect width="400" height="400" fill="transparent" />

            <ellipse cx="200" cy="310" rx="140" ry="35" fill="url(#sysPlatform)" stroke="#ff5e00" strokeWidth="1" />
            <ellipse cx="200" cy="315" rx="140" ry="35" fill="none" stroke="#ff5e00" strokeWidth="2" opacity="0.4" />
            
            <g transform="translate(110, 260)">
              <rect x="0" y="10" width="40" height="40" rx="5" fill="#222" stroke="#444" />
              <ellipse cx="20" cy="10" rx="20" ry="7" fill="#333" stroke="#444" />
              <ellipse cx="20" cy="22" rx="20" ry="7" fill="#333" stroke="#444" />
              <ellipse cx="20" cy="34" rx="20" ry="7" fill="#333" stroke="#444" />
              <circle cx="8" cy="18" r="2.5" fill="#00ff66" className="blink-fast" />
              <circle cx="8" cy="30" r="2.5" fill="#00f0ff" className="blink-slow" />
              <text x="20" y="58" fill="#aaa" fontSize="8" textAnchor="middle" fontWeight="bold">DATABASE</text>
            </g>

            <ellipse cx="200" cy="210" rx="120" ry="30" fill="url(#sysPlatform)" stroke="#00f0ff" strokeWidth="1" />
            
            <g transform="translate(240, 160)">
              <g className="spinning-cog">
                <circle cx="25" cy="25" r="18" fill="none" stroke="#00f0ff" strokeWidth="6" strokeDasharray="8 6" />
                <circle cx="25" cy="25" r="10" fill="#222" stroke="#00f0ff" strokeWidth="2" />
              </g>
            </g>
            <text x="265" y="210" fill="#00f0ff" fontSize="8" textAnchor="middle" fontWeight="bold">ENGINE</text>

            <ellipse cx="200" cy="110" rx="100" ry="25" fill="url(#sysPlatform)" stroke="#7000ff" strokeWidth="1" />
            
            <g transform="translate(160, 55)">
              <g className="floating-illustration">
                <path d="M 15 25 A 12 12 0 0 1 30 15 A 16 16 0 0 1 65 18 A 12 12 0 0 1 75 30 Z" fill="url(#sysLight)" opacity="0.3" filter="url(#sysGlow)" />
                <path d="M 20 28 L 35 18 L 50 24 L 68 12" fill="none" stroke="#7000ff" strokeWidth="2.5" strokeLinecap="round" />
                <circle cx="68" cy="12" r="3" fill="#ff007f" />
                <text x="40" y="42" fill="#fff" fontSize="8" textAnchor="middle" fontWeight="bold">FRONTEND API</text>
              </g>
            </g>

            <g className="data-flow" fill="#ff5e00" filter="url(#sysGlow)">
              <circle cx="150" cy="260" r="4" className="flow-dot-1" />
              <circle cx="230" cy="160" r="4" className="flow-dot-2" />
              <circle cx="180" cy="120" r="4" className="flow-dot-3" />
            </g>
          </svg>
        );
      case "payment":
        return (
          <svg className="carousel-svg payment-svg" viewBox="0 0 400 400" width="100%" height="100%">
            <defs>
              <linearGradient id="cardGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ff007f" />
                <stop offset="50%" stopColor="#7000ff" />
                <stop offset="100%" stopColor="#00f0ff" />
              </linearGradient>
              <linearGradient id="coinGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ffbd2e" />
                <stop offset="100%" stopColor="#ff5e00" />
              </linearGradient>
              <filter id="cardShadow" x="-10%" y="-10%" width="130%" height="130%">
                <feDropShadow dx="0" dy="15" stdDeviation="15" floodColor="#7000ff" floodOpacity="0.45" />
              </filter>
            </defs>
            <rect width="400" height="400" fill="transparent" />

            <circle cx="200" cy="200" r="120" fill="#7000ff" opacity="0.08" className="pulse-slow" />

            <g transform="rotate(-12, 200, 180)" filter="url(#cardShadow)">
              <g className="floating-illustration">
                <rect x="70" y="100" width="260" height="160" rx="18" fill="url(#cardGrad)" stroke="rgba(255,255,255,0.25)" strokeWidth="1.5" />
                <circle cx="280" cy="140" r="22" fill="#fff" opacity="0.1" />
                <circle cx="295" cy="140" r="22" fill="#fff" opacity="0.15" />
                
                <rect x="100" y="140" width="35" height="25" rx="5" fill="#f0c050" stroke="#d4a317" strokeWidth="0.5" />
                <line x1="100" y1="152.5" x2="135" y2="152.5" stroke="#d4a317" strokeWidth="0.5" />
                <line x1="117.5" y1="140" x2="117.5" y2="165" stroke="#d4a317" strokeWidth="0.5" />

                <rect x="100" y="190" width="50" height="6" rx="3" fill="#fff" opacity="0.6" />
                <rect x="160" y="190" width="50" height="6" rx="3" fill="#fff" opacity="0.6" />
                <rect x="220" y="190" width="50" height="6" rx="3" fill="#fff" opacity="0.6" />

                <text x="100" y="235" fill="#fff" fontSize="10" fontWeight="bold" letterSpacing="1.5" opacity="0.8">MARSMATE PREMIUM</text>
                <circle cx="290" cy="230" r="8" fill="#ff5e00" opacity="0.8" />
                <circle cx="300" cy="230" r="8" fill="#ffbd2e" opacity="0.8" />
              </g>
            </g>

            <g className="floating-illustration-alt">
              <circle cx="70" cy="280" r="15" fill="url(#coinGrad)" stroke="#fff" strokeWidth="1" />
              <text x="70" y="285" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">$</text>
              
              <circle cx="330" cy="100" r="18" fill="url(#coinGrad)" stroke="#fff" strokeWidth="1" />
              <text x="330" y="106" fill="#fff" fontSize="15" fontWeight="bold" textAnchor="middle">₹</text>
            </g>

            <g transform="translate(180, 220)">
              <g className="floating-illustration">
                <circle cx="60" cy="60" r="30" fill="#132a1e" stroke="#00ff66" strokeWidth="2.5" />
                <circle cx="60" cy="60" r="25" fill="#00ff66" opacity="0.2" className="pulse-slow" />
                <path d="M 48 60 L 56 68 L 72 52" fill="none" stroke="#00ff66" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
              </g>
            </g>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="main-container">
      {/* Left Card - Form */}
      <div className="card-left">
        <div className="tab-buttons">
          <button
            className={activeForm === "contact" ? "active" : ""}
            onClick={() => setActiveForm("contact")}
          >
            Get in Touch
          </button>
          <button
            className={activeForm === "requirement" ? "active" : ""}
            onClick={() => setActiveForm("requirement")}
          >
            Your Requirement
          </button>
        </div>

        {/* Contact Form */}
        {activeForm === "contact" && (
          <form className="form-box" onSubmit={handleContactSubmit}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              value={contactData.name}
              onChange={handleContactChange}
            />
            <label>Email</label>
            <input
              type="text"
              name="email"
              placeholder="Enter your email"
              value={contactData.email}
              onChange={handleContactChange}
            />
            <label>Mobile</label>
            <input
              type="text"
              name="mobile"
              placeholder="Enter mobile number"
              value={contactData.mobile}
              onChange={handleContactChange}
            />
            <label>Problem</label>
            <textarea
              name="problem"
              placeholder="Say your problem..."
              rows="4"
              value={contactData.problem}
              onChange={handleContactChange}
            ></textarea>
            <button type="submit">Submit Contact</button>
          </form>
        )}

        {/* Requirement Form */}
        {activeForm === "requirement" && (
          <form className="form-box" onSubmit={handleRequirementSubmit}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              value={requirementData.name}
              onChange={handleRequirementChange}
            />
            <label>Email</label>
            <input
              type="text"
              name="email"
              placeholder="Enter your email"
              value={requirementData.email}
              onChange={handleRequirementChange}
            />
            <label>Mobile</label>
            <input
              type="text"
              name="mobile"
              placeholder="Enter mobile number"
              value={requirementData.mobile}
              onChange={handleRequirementChange}
            />
            <label>Problem</label>
            <textarea
              name="problem"
              placeholder="Say your problem..."
              rows="4"
              value={requirementData.problem}
              onChange={handleRequirementChange}
            ></textarea>
            <button type="submit">Submit Requirement</button>
          </form>
        )}
      </div>

      {/* Right Card - Carousel */}
        <div className="card-right carousel-container">
        <div className="theimages">
          {renderSlideContent(slides[currentIndex])}
        </div>
          <div className="carousel-dots">
            {slides.map((_, index) => (
              <span
                key={index}
                className={currentIndex === index ? "dot active" : "dot"}
                onClick={() => setCurrentIndex(index)}
              ></span>
            ))}
          </div>
        </div>
    </div>
  );
}

export default FormsScroll;
